import { createContext, useContext, useEffect, useState } from "react";
import {
  OAuthProvider,
  signInWithPopup,
  signOut,
  onAuthStateChanged,
  GoogleAuthProvider,
} from "firebase/auth";
import { auth } from "../config";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // ✅ Login con Google (usando popup)
  const loginWithGoogle = async () => {
    try {
      const provider = new GoogleAuthProvider();
      provider.setCustomParameters({ prompt: "select_account" });

      const result = await signInWithPopup(auth, provider);
      return result; // contiene { user, credential }
    } catch (error) {
      console.error("Error al iniciar sesión con Google:", error);
      throw error;
    }
  };

  const loginWithApple = async () => {
    const appleProvider = new OAuthProvider("apple.com");
    appleProvider.setCustomParameters({ prompt: "select_account" });
    try {
      const result = await signInWithPopup(auth, appleProvider);
      return result;
    } catch (error) {
      console.error("Apple Sign-In Error:", error);
      throw error;
    }
  };

  const loginWithMicrosoft = async () => {
    try {
      const msProvider = new OAuthProvider("microsoft.com");
      msProvider.setCustomParameters({ prompt: "select_account" });
      const result = await signInWithPopup(auth, msProvider);
      return result;
    } catch (error) {
      console.error("Microsoft Sign-In Error:", error);
      throw error;
    }
  };

  const logout = async () => {
    try {
      await signOut(auth);
      sessionStorage.removeItem("geoSent");
    } catch (error) {
      console.error("Error al cerrar sesión:", error);
      throw error;
    }
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  const value = {
    currentUser,
    loginWithGoogle,
    loginWithApple,
    loginWithMicrosoft,
    logout,
    loading,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}